import React from 'react';
import {ThemeProvider} from '../../../ui-library';
import {
    PageBox,
    BackBtn,
    BackIcon,
    TabsBox,
    ButtonsBox,
    StopBtn, StopIcon, LoadingBox
} from '../Style/AutoProject.style';
import useAutoProject from '../Controller/AutoProject.controller';
import useTabPanel from '../../../Containers Components/TabPanel/Controller/TabPanel.controller';
import {AutoProjectStatusPageMetaDataView} from '../../../Containers Components/AutoProjectStatusPageMetaData/index';
import {AutoProjectImageCollectionTabView} from '../../../Containers Components/AutoProjectImageCollectionTab/index';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {AutoProjectStatusTabsView} from '../../../Containers Components/AutoProjectStatusTabs/index';
import AutoProjectTrainingStatusTabView from '../../../Containers Components/AutoProjectTrainingStatusTab/View/AutoProjectTrainingStatusTab.view';
import BeforeExitModalView from '../../../Containers Components/BeforeExitModal/View/BeforeExitModal.view';
import {ProjectFlowPhase} from '../Config/AutoProject.constants';
import {StatusAlert} from '../../../Containers Components/AutoProjectImageCollectionTab/Style/AutoProjectImageCollectionTab.style';
import {alertsArr} from '../../../Containers Components/AutoProjectImageCollectionTab/Config/AutoProjectImageCollectionTab.constants';
import Loading from '../../../Presentational Components/Loading';
const AutoProjectView = () => {
    const {projectIdInit, autoProjectState, navigateToDataProjects, goToManualRefinement, setState, startTrainingBtn, stopAutoProject, setOpenStopModal, openStopModal} = useAutoProject();
    const {value, handleChange, setValue} = useTabPanel();
    const severityAlertType = alertsArr[autoProjectState.messageBoxFlowPhase] && alertsArr[autoProjectState.messageBoxFlowPhase]['type'];
    const alertMessage = alertsArr[autoProjectState.messageBoxFlowPhase] && alertsArr[autoProjectState.messageBoxFlowPhase]['message'];
    const isLoading = autoProjectState.projectId === -1;


    return (
        <ThemeProvider>
            {isLoading
                ? <LoadingBox><Loading title='Loading' className='loading-table'/></LoadingBox>
                : <PageBox>
                    <ButtonsBox>
                        <BackBtn onClick={navigateToDataProjects} startIcon={<BackIcon/>} size='small' >{_SYSTEM_TITLES.backToProjectsBtn}</BackBtn>
                        {autoProjectState.projectFlowPhase !== ProjectFlowPhase.Stopped && autoProjectState.projectFlowPhase > -1
                            ? <StopBtn onClick={() => setOpenStopModal(true)} variant='outlined' startIcon={<StopIcon/>} size='large'>{_SYSTEM_TITLES.autoProjectStatusPageStopBtn}</StopBtn>
                            : null}
                    </ButtonsBox>

                    <>
                        <AutoProjectStatusPageMetaDataView
                            autoProjectState={autoProjectState}
                        />
                        <BeforeExitModalView
                            title={_SYSTEM_TITLES.autoProjectStopModalTitle}
                            content={_SYSTEM_TITLES.autoProjectStopModalContent}
                            yesTitle={_SYSTEM_TITLES.autoProjectStopModalStopBtn}
                            cancelTitle={_SYSTEM_TITLES.autoProjectStopModalCancelBtn}
                            open={openStopModal}
                            setOpen={setOpenStopModal}
                            onClick={stopAutoProject}
                            yestextcolor={'red'}/>
                        {severityAlertType && <StatusAlert severity={severityAlertType}> {alertMessage}</StatusAlert>}
                        <TabsBox>
                            <AutoProjectStatusTabsView
                                value={value}
                                handleChange={handleChange}
                            />
                            <AutoProjectImageCollectionTabView
                                goToManualRefinement={goToManualRefinement}
                                value={value}
                                autoProjectState={autoProjectState}
                                startTrainingBtn={startTrainingBtn}
                                setValue={setValue}
                            />
                            <AutoProjectTrainingStatusTabView
                                value={value}
                                autoProjectState={autoProjectState}
                                projectIdInit={projectIdInit}
                                setState={setState}
                            />
                        </TabsBox>
                    </>
                </PageBox>
            }
        </ThemeProvider>
    );
};

export default AutoProjectView;
